/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloDivisionesDocumentosDefecto from 'Infotrack@Modelos/smartStock/divisionesDocumentosDefecto';
import IDivisionesDefectoFiltros from 'Infotrack@Modelos/smartStock/divisionesDocumentosDefecto/entidades/divisionesDefectoFiltros';
import IDivisionesDocumentosDefecto from 'Infotrack@Modelos/smartStock/divisionesDocumentosDefecto/entidades/divisionesDocumentosDefecto';

export default class ControladorModeloDivisionesDocumentosDefecto {
    private modeloDivisionesDocumentosDefecto: ModeloDivisionesDocumentosDefecto;
    constructor() {
        this.modeloDivisionesDocumentosDefecto = new ModeloDivisionesDocumentosDefecto();
    }

    public consultarDivisionesDocumentosDefecto() {
        return this.modeloDivisionesDocumentosDefecto
            .consultarDivisionesDocumentosDefecto()
            .then(({ data: { Entidades } }) => Entidades);
    }

    public consultaDivisionesPorDefectoCompuestaFiltrada(divisionesDefectoFiltros: IDivisionesDefectoFiltros) {
        return this.modeloDivisionesDocumentosDefecto
            .consultaDivisionesPorDefectoCompuestaFiltrada(divisionesDefectoFiltros)
            .then(({ data: { Entidades } }) => Entidades);
    }

    public async crearDivisionesDocumentosDefecto(divisionesDocumentosDefecto: IDivisionesDocumentosDefecto) {
        await this.modeloDivisionesDocumentosDefecto.crearDivisionesDocumentosDefecto(divisionesDocumentosDefecto);
    }

    public async editarDivisionesDocumentosDefecto(divisionesDocumentosDefecto: IDivisionesDocumentosDefecto) {
        await this.modeloDivisionesDocumentosDefecto.editarDivisionesDocumentosDefecto(divisionesDocumentosDefecto);
    }
    public async eliminarDivisionesDocumentosDefecto(divisionesDocumentosDefecto: IDivisionesDocumentosDefecto) {
        await this.modeloDivisionesDocumentosDefecto.eliminarDivisionesDocumentosDefecto(divisionesDocumentosDefecto);
    }

    public validarEntidad(divisionesDocumentosDefecto: IDivisionesDocumentosDefecto): boolean {
        if (divisionesDocumentosDefecto.TipoDocumentoId === 0 || divisionesDocumentosDefecto.DivisionId === 0) {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }

    public async activarDivisionPorDefecto(divisionesDocumentosDefecto: IDivisionesDocumentosDefecto) {
        await this.modeloDivisionesDocumentosDefecto.activarDivisionPorDefecto(divisionesDocumentosDefecto);
    }
}
